var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFrame3 = function SvgFrame3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.654 70.846a4.972 4.972 0 0 0 4.978 4.978h69.821a4.972 4.972 0 0 0 4.978-4.978V36.253H31.654v34.593Z",
    fill: "#FFB9B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.453 20.742h-69.82a4.972 4.972 0 0 0-4.979 4.978v6.88h79.777v-6.88a4.979 4.979 0 0 0-4.978-4.978Z",
    fill: "#FFBAB3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.536 29.73a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM46.462 29.73a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM53.215 29.73a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    fill: "#FC8177"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.672 97.154a4.955 4.955 0 0 0 4.955 4.955H90.09a4.955 4.955 0 0 0 4.955-4.955V62.745H15.672v34.41Z",
    fill: "url(#Frame3_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.079 47.315H20.615a4.955 4.955 0 0 0-4.955 4.956v6.844h79.362V52.27a4.93 4.93 0 0 0-4.944-4.955Z",
    fill: "url(#Frame3_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.897 55.705a2.49 2.49 0 1 0 0-4.978 2.49 2.49 0 0 0 0 4.978ZM29.776 55.705a2.49 2.49 0 1 0 0-4.978 2.49 2.49 0 0 0 0 4.978ZM36.495 55.705a2.49 2.49 0 1 0 0-4.978 2.49 2.49 0 0 0 0 4.978Z",
    fill: "#FC8075"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M52.225 95.794a2.147 2.147 0 0 1-2.086-2.697l6.073-23.08a2.152 2.152 0 0 1 2.627-1.533 2.147 2.147 0 0 1 1.533 2.627l-6.073 23.081a2.129 2.129 0 0 1-2.074 1.602ZM45.783 92.188c-.6 0-1.187-.242-1.614-.726l-7.478-8.47a2.142 2.142 0 0 1 .092-2.938l8.47-8.47a2.15 2.15 0 0 1 3.042 0 2.15 2.15 0 0 1 0 3.042l-7.041 7.03 6.142 6.96a2.14 2.14 0 0 1-.196 3.03 2.161 2.161 0 0 1-1.417.542ZM63.92 92.188a2.11 2.11 0 0 1-1.522-.634 2.15 2.15 0 0 1 0-3.042l7.041-7.041-6.142-6.96a2.14 2.14 0 0 1 .196-3.03 2.14 2.14 0 0 1 3.03.195l7.48 8.47a2.143 2.143 0 0 1-.093 2.938l-8.47 8.47a2.11 2.11 0 0 1-1.52.634Z",
    fill: "#F2F2F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Frame3_svg__a",
    x1: 24.213,
    y1: 49.837,
    x2: 83.387,
    y2: 109.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD948C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD867B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Frame3_svg__b",
    x1: 37.37,
    y1: 36.68,
    x2: 96.543,
    y2: 95.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8278"
  })))));
};
export default SvgFrame3;